"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseStringHandler = require("../BaseStringHandler");
var secondsPerHour = 3600;
var secondsPerMinute = 60;
var hoursPerDay = 24;
var DurationHandler = /*#__PURE__*/function (_BaseStringHandler) {
  function DurationHandler() {
    (0, _classCallCheck2["default"])(this, DurationHandler);
    return _callSuper(this, DurationHandler, arguments);
  }
  (0, _inherits2["default"])(DurationHandler, _BaseStringHandler);
  return (0, _createClass2["default"])(DurationHandler, [{
    key: "format",
    value: function format(s) {
      var days = Math.trunc(s / (hoursPerDay * secondsPerHour));
      s = Math.abs(s);
      return days ? "".concat(days, "+ days") : "".concat("".concat(Math.floor(s / secondsPerHour) % hoursPerDay).padStart(2, "0"), ":").concat("".concat(Math.floor(s / secondsPerMinute) % secondsPerMinute).padStart(2, "0"), ":").concat("".concat(Math.floor(s % secondsPerMinute)).padStart(2, "0"));
    }
  }]);
}(BaseStringHandler);
module.exports = DurationHandler;